<template>
  <div>
    <KTCodePreview v-bind:title="'Danh sách danh mục sản phẩm'">
      <template v-slot:toolbar>
        <b-row>
          <span
            v-show="checkPermission('CATE_INSERT')"
            v-b-tooltip.hover
            :title="isCreateCategoryBlocked ? createCategoryBlockedTooltip : ''"
            class="d-inline-block"
          >
            <b-button
              size="sm"
              variant="primary"
              class="font-weight-bolder"
              :disabled="isCreateCategoryBlocked"
              @click="showModalAddCate"
            >
              <i class="flaticon2-add-1 icon-size-1-rem"></i>
              Tạo mới
            </b-button>
          </span>
        </b-row>
      </template>
      <template v-slot:preview>
        <div class="mb-5">
          <b-form>
            <div class="row">
              <b-col cols="8">
                <div class="row">
                  <b-col md="4">
                    <b-input
                      size="sm"
                      placeholder="Tìm kiếm theo tên"
                      v-model.trim="searchName"
                      v-on:keyup.enter="searchCate"
                      autocomplete="off"
                    />
                  </b-col>
                  <b-col md="4">
                    <b-input
                      size="sm"
                      placeholder="Tìm kiếm theo mã"
                      v-model.trim="searchCode"
                      v-on:keyup.enter="searchCate"
                      autocomplete="off"
                    />
                  </b-col>
                  <b-col md="1">
                    <b-button
                      size="sm"
                      variant="primary"
                      style="width: 70px"
                      @click="onFilter"
                      >Lọc</b-button
                    >
                  </b-col>
                  <b-col class="ml-6 d-flex">
                    <b-button
                      v-if="show"
                      v-b-tooltip.hover
                      title="Ẩn tất cả danh mục"
                      size="sm"
                      variant="secondary"
                      @click="hideAllCollapse"
                    >
                      <i style="padding-right: 0" class="fa fa-eye-slash"></i>
                    </b-button>
                    <b-button
                      v-else
                      v-b-tooltip.hover
                      title="Hiện tất cả danh mục"
                      size="sm"
                      variant="secondary"
                      @click="showAllCollapse"
                    >
                      <i style="padding-right: 0" class="fa fa-eye"></i>
                    </b-button>
                    <b-button
                      size="sm"
                      class="ml-2"
                      v-b-tooltip.hover
                      title="Reset dữ liệu"
                      @click="resetData"
                      variant="secondary"
                    >
                      <i style="padding-right: 0" class="fa fa-redo"></i>
                    </b-button>
                  </b-col>
                </div>
              </b-col>
            </div>
          </b-form>
        </div>

        <b-modal
          ref="add-cate-modal"
          @hide="onHide"
          hide-footer
          title="Thêm mới danh mục"
        >
          <v-form v-model="valid" lazy-validation>
            <div class="w-50">
              <b-form-group>
                <label>Danh mục cha:</label>
                <b-form-input
                  disabled
                  v-if="parentCateId"
                  v-model="parentCateName"
                />
                <treeselect
                  v-else
                  :options="listItem"
                  :multiple="false"
                  placeholder="Chọn danh mục cha"
                  :match-keys="['id', 'label']"
                  v-model="selectedParent"
                  :clearable="true"
                  :show-count="true"
                  openDirection="bottom"
                >
                </treeselect>
              </b-form-group>
            </div>
            <div class="w-50">
              <b-form-group>
                <label>Tên:</label>
                <span class="text-danger">*</span>
                <b-form-input
                  size="sm"
                  placeholder="Nhập tên"
                  v-model.trim="name"
                  :state="validateState('name')"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.name.required"
                  >Yêu cầu nhập tên danh mục</b-form-invalid-feedback
                >
              </b-form-group>
            </div>
            <div class="w-50">
              <b-form-group>
                <label>Mã:</label>
                <span class="text-danger">*</span>
                <b-form-input
                  size="sm"
                  placeholder="Nhập mã"
                  v-model.trim="code"
                  :state="validateState('code')"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.code.required"
                  >Yêu cầu nhập mã danh mục</b-form-invalid-feedback
                >
              </b-form-group>
            </div>

            <span
              v-show="checkPermission('CATE_INSERT')"
              v-b-tooltip.hover
              :title="isCreateCategoryBlocked ? createCategoryBlockedTooltip : ''"
              class="d-inline-block mr-3"
            >
              <b-button
                size="sm"
                variant="primary"
                style="width: 70px"
                :disabled="isCreateCategoryBlocked"
                @click="createCategory"
                >Lưu</b-button
              >
            </span>
            <b-button
              size="sm"
              variant="secondary"
              style="width: 70px"
              @click="hideModalAddCate"
              >Hủy</b-button
            >
          </v-form>
        </b-modal>
        <b-modal ref="update-cate-modal" hide-footer title="Cập nhật danh mục">
          <v-form ref="form" v-model="valid" lazy-validation>
            <div class="w-50">
              <b-form-group>
                <label>Danh mục cha:</label>
                <treeselect
                  :options="listItem"
                  :multiple="false"
                  placeholder="Chọn danh mục cha"
                  :match-keys="['id', 'label']"
                  v-model="selectedParent"
                  :clearable="true"
                  :show-count="true"
                  openDirection="bottom"
                  @input="handleTreeselectInput"
                >
                </treeselect>
              </b-form-group>
            </div>
            <div class="w-50">
              <b-form-group>
                <label>Tên:</label>
                <span class="text-danger">*</span>
                <b-form-input
                  size="sm"
                  placeholder="Nhập tên"
                  v-model="name"
                  :state="validateState('name')"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.name.required"
                  >Yêu cầu nhập tên danh mục</b-form-invalid-feedback
                >
              </b-form-group>
            </div>
            <div class="w-50">
              <b-form-group>
                <label>Mã:</label>
                <span class="text-danger">*</span>
                <b-form-input
                  size="sm"
                  placeholder="Nhập mã"
                  v-model="code"
                  :state="validateState('code')"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.code.required"
                  >Yêu cầu nhập mã danh mục</b-form-invalid-feedback
                >
              </b-form-group>
            </div>

            <b-button
              size="sm"
              variant="primary"
              class="mr-3 mt-2"
              style="width: 70px"
              @click="updateCategory"
              v-show="checkPermission('CATE_UPDATE')"
              >Lưu</b-button
            >
            <b-button
              style="width: 70px"
              variant="secondary"
              size="sm"
              @click="hideModalUpdateCate"
              >Hủy</b-button
            >
          </v-form>
        </b-modal>
        <b-modal
          ref="merge-tree-cate-modal"
          hide-footer
          title="Di chuyển cây danh mục"
        >
          <v-form>
            <div class="w-50">
              <b-form-group>
                <label>Danh mục cha:</label>
                <treeselect
                  :options="listItem"
                  :multiple="false"
                  placeholder="Chọn danh mục cha"
                  :match-keys="['id', 'label']"
                  v-model="targetCateToBeMerged"
                  :clearable="true"
                  :show-count="true"
                  openDirection="bottom"
                >
                </treeselect>
              </b-form-group>

              <b-button
                size="sm"
                variant="primary"
                class="mr-3"
                style="width: 130px"
                @click="mergeTreeCategory"
                >Di chuyển tới đây</b-button
              >
              <b-button
                style="width: 70px"
                variant="secondary"
                size="sm"
                @click="hideMergeTreeModal"
                >Hủy</b-button
              >
            </div>
          </v-form>
        </b-modal>
        <b-modal ref="merge-cate-modal" hide-footer title="Gộp danh mục">
          <div class="d-flex">
            <div class="w-50">
              <b-form-group>
                <label>Từ danh mục:</label>
                <p>
                  <b> {{ categoryMerge.picked.name }}</b>
                </p>
              </b-form-group>
            </div>
            <div class="w-50">
              <b-form-group>
                <b-form-group>
                  <label>Đến danh mục:</label>
                  <b-form-select
                    size="sm"
                    v-model="categoryMerge.mergedId"
                    :options="listMergeTreeCate"
                    @change="onChangeMergeCate"
                    value-field="id"
                    text-field="name"
                  >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled
                        >Chọn danh mục</b-form-select-option
                      >
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-form-group>
            </div>
          </div>

          <b-button
            size="sm"
            variant="primary"
            class="mr-3"
            style="width: 70px"
            @click="onMergeCate"
            v-show="checkPermission('CATE_UPDATE')"
            >Lưu</b-button
          >
          <b-button
            style="width: 70px"
            variant="secondary"
            size="sm"
            @click="$refs['merge-cate-modal'].hide()"
            >Hủy</b-button
          >
        </b-modal>
        <div ref="loadMoreCategory">
          <b-table
            :items="listItem"
            :fields="fields"
            bordered
            hover
            :busy="onLoading"
          >
            <template v-slot:table-busy>
              <vcl-table :speed="5" :animate="true" :columns="6"></vcl-table>
            </template>
            <template v-slot:cell(stt)="row">
              <div class="d-flex justify-content-center w-6">
                <span v-text="row.item.stt"></span>
              </div>
            </template>
            <template v-slot:cell(name)="row">
              <!-- list item level 0 -->
              <li
                class="list-level-0"
                v-b-toggle:[`list-itemlv1-${row.item.id}`]
              >
                <p v-html="highlightMatchesName(row.item.name)"></p>
                <span
                  class="categories_quantity"
                  v-if="row.item.children.length"
                >
                  ({{ row.item.children.length }})
                </span>
                <!-- Make the arrow appear if parent item has child items -->
                <i
                  v-if="row.item.children.length > 0"
                  class="fa fa-angle-down arrow-level-0"
                ></i>
              </li>
              <b-collapse
                :ref="`collapse-${row.item.id}`"
                :id="`list-itemlv1-${row.item.id}`"
              >
                <ListItemCate
                  v-for="itemLv1 in row.item.children"
                  :key="itemLv1.id"
                  :item="itemLv1"
                  :can-create-category="canCreateCategory"
                  :create-category-blocked-tooltip="createCategoryBlockedTooltip"
                  @editItem="editItem"
                  @popupMergeCate="popupMergeCate"
                  @showMergeTreeModal="showMergeTreeModal"
                  @addChildCate="addChildCate"
                  @showDeleteAlert="showDeleteAlert"
                  :internalCate="true"
                  :searchName="searchName"
                  ref="collapseAll"
                >
                </ListItemCate>
              </b-collapse>
            </template>
            <template v-slot:cell(code)="row">
              <b v-html="highlightMatchesCode(row.item.code)"></b>
            </template>
            <template v-slot:cell(actions)="row">
              <div class="d-flex justify-content-center">
                <b-dropdown size="sm" no-caret right lazy>
                  <template slot="button-content">
                    <i class="flaticon2-settings icon-size-1-rem pr-0"></i>
                  </template>
                  <b-dropdown-item
                    @click="editItem(row.item)"
                    v-if="checkViewOnly()"
                  >
                    <span style="color: #3f4254; font-size: 12px">
                      <i class="flaticon2-box-1 icon-size-1-rem"></i>
                      &nbsp; Chi tiết
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="editItem(row.item)"
                    v-if="!checkViewOnly()"
                  >
                    <span style="color: #3f4254; font-size: 12px">
                      <i class="flaticon2-pen icon-size-1-rem"></i>
                      &nbsp; Chỉnh sửa
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="popupMergeCate(row.item)"
                    v-if="checkPermission('CATE_MERGE')"
                  >
                    <span style="color: #3f4254; font-size: 12px">
                      <i
                        class="fas fa-layer-group text-warning icon-size-1-rem"
                      ></i>
                      &nbsp; Gộp danh mục
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="showMergeTreeModal(row.item)"
                    v-show="checkPermission('CATE_MOVE')"
                  >
                    <span style="color: #3f4254; font-size: 12px">
                      <i
                        style="color: #8908fd"
                        class="flaticon-arrows icon-size-1-rem"
                      ></i>
                      &nbsp; Di chuyển danh mục
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    :disabled="isCreateCategoryBlocked"
                    v-b-tooltip.hover
                    :title="
                      isCreateCategoryBlocked ? createCategoryBlockedTooltip : ''
                    "
                    @click="addChildCate(row.item)"
                    v-show="checkPermission('CATE_INSERT')"
                  >
                    <span style="color: #3f4254; font-size: 12px">
                      <i
                        style="color: #1bc5bc"
                        class="fas fa-plus icon-size-1-rem"
                      ></i>
                      &nbsp; Thêm danh mục con
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="showDeleteAlert(row.item)"
                    v-show="checkPermission('CATE_DELETE')"
                  >
                    <span style="color: #3f4254; font-size: 12px">
                      <i
                        style="color: #d33"
                        class="flaticon2-rubbish-bin-delete-button icon-size-1-rem"
                      ></i>
                      &nbsp; Xóa
                    </span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </template>
          </b-table>

          <b-row>
            <b-col>
              <p class="mt-3 text-dark" style="font-weight: 500">
                Tổng số:
                {{ listItem.length }}
              </p>
            </b-col>
          </b-row>
        </div>
      </template>
    </KTCodePreview>
  </div>
</template>

<style scoped>
.icon-size-1-rem {
  font-size: 1rem !important;
}
.icon {
  padding-top: 7px;
}
.ml-10 {
  margin-left: 5px;
}
.ml-20 {
  margin-left: 10px;
}
.ml-30 {
  margin-left: 15px;
}
.ml-40 {
  margin-left: 20px;
}
.ml-50 {
  margin-left: 25px;
}
.sttCateClass {
  width: 6%;
}
.nameCateClass {
  width: 45%;
}
.codeCateClass {
  width: 45%;
}

.icon:hover {
  background-color: #90c6fc;
}

.container-fluid {
  height: 100%;
  display: table;
  width: 100%;
  padding: 0;
}

.row-fluid {
  height: 100%;
  display: table-cell;
  vertical-align: middle;
}

.centering {
  float: none;
  margin: 0 auto;
}
.dropdown-menu li {
  line-height: 15px;
}
.arrow-level-0 {
  position: absolute;
  color: #464e5f;
  right: 30px;
  font-size: 20px;
  top: 5px;
}

.action-level-1 {
  position: absolute;
  top: 5px;
  right: 20px;
}

.action-level-1 i {
  color: #464e5f;
  font-size: 18px;
}

.action-level-1 .arrow-down {
  margin-right: 10px;
}

.action-level-2 {
  position: absolute;
  top: 5px;
  right: 20px;
}

.action-level-2 i {
  color: #464e5f;
  font-size: 18px;
}

.action-level-2 .arrow-down {
  margin-right: 10px;
}

.action-level-3 {
  position: absolute;
  top: 5px;
  right: 20px;
}

.action-level-3 i {
  color: #464e5f;
  font-size: 18px;
}

.action-level-3 .arrow-down {
  margin-right: 10px;
}

.list-level-0 {
  position: relative;
  list-style-type: none;
  font-weight: bolder;
  color: #464e5f;
}

.categories_quantity {
  position: absolute;
  top: 6px;
  right: 50px;
  font-weight: lighter;
}

.list-level-1 {
  list-style-type: decimal;
  margin-left: 10px;
  line-height: 40px;
  position: relative;
}

.list-level-1 .arrow-down-level-1 {
  position: absolute;
  color: #464e5f;
  right: 66px;
  top: 18px;
}

.list-level-2 {
  list-style-type: circle;
  margin-left: 12px;
  line-height: 35px;
  position: relative;
}

.list-level-2 .arrow-down-level-2 {
  position: absolute;
  color: #464e5f;
  right: 66px;
  top: 18px;
}

.list-level-3 {
  list-style-type: square;
  margin-left: 24px;
  line-height: 35px;
  position: relative;
}
.collapsing {
  transition: none !important;
}
</style>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import Swal from 'sweetalert2';
import ApiService from '@/core/services/api.service';
import { validationMixin } from 'vuelidate';
import { VclTable } from 'vue-content-loading';
import { required } from 'vuelidate/lib/validators';
import { chunk } from 'lodash';
import { getDeepByDescendant, getDescendantCategories } from '@/utils/common';
import ListItemCate from '@/view/components/ListItemCate.vue';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { removeAccents } from '@/utils/common';
import { TIME_TRIGGER } from '@/utils/constants';
import debounce from 'debounce';
import permissionMixin from '@/view/mixins/permission.mixin';
import allowCreateCategoryMixin from '@/view/mixins/allowCreateCategory.mixin';

export default {
  name: 'ListCategory',
  mixins: [validationMixin, permissionMixin, allowCreateCategoryMixin],
  data() {
    return {
      searchName: '',
      searchCode: '',
      show: false,
      fields: [
        {
          key: 'stt',
          label: 'STT',
          sortable: false,
          thStyle: { textAlign: 'center', fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'name',
          label: 'Tên danh mục',
          sortable: false,
          tdClass: 'nameCateClass',
          thClass: 'nameCateClass',
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'code',
          label: 'Mã danh mục',
          sortable: false,
          tdClass: 'codeCateClass',
          thClass: 'codeCateClass',
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        { key: 'actions', label: '' },
      ],
      listItem: [],
      page: 1,
      count: 1,
      listCate: [],
      selectedParent: null,
      listMergeTreeCate: [],
      targetCateToBeMerged: null,
      cateToBeMerged: null,
      name: '',
      code: '',
      valid: true,
      cateId: 0,
      totalRow: 0,
      onLoading: false,
      submitted: false,
      isNew: true,
      chunkData: [],
      isLoadMore: false,
      categoryMerges: [],
      categoryMerge: {
        picked: {},
        merged: {},
        mergedId: null,
      },
      listCateParent: [],
      parentCateId: null,
      parentCateName: '',
      parentCateCode: '',
      listPurchasingDepartment: [],
      optionsPurchasingDepartment: [],
      purchasingDepartmentId: null,
      searchPurchasingDepartment: '',
      isLoadingParentCategories: false,
    };
  },
  components: {
    KTCodePreview,
    VclTable,
    ListItemCate,
    Treeselect,
  },
  validations: {
    name: {
      required,
    },
    code: {
      required,
    },
  },
  created() {
    this.getListCate();
    this.fetchData();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Danh mục sản phẩm' }]);
    this.show = false;

    // this.$nextTick(function () {
    //   window.addEventListener('scroll', this.onScrollCategory);
    //   this.onScrollCategory();
    // });
  },
  // beforeDestroy() {
  //   window.removeEventListener('scroll', this.onScrollCategory);
  // },
  computed: {},
  methods: {
    handleTreeselectInput(value) {
      this.selectedParent = value === undefined ? null : value;
    },
    onHide(evt) {
      if (evt.trigger === 'backdrop') {
        this.parentCateId = null;
        this.parentCatename = '';
        this.parentCateCode = '';
      }
    },
    debounceShowAllCollapse: debounce(function () {
      this.showAllCollapse();
    }, TIME_TRIGGER),
    searchCate() {
      this.fetchData();
      if (this.searchName.trim() || this.searchCode.trim()) {
        this.debounceShowAllCollapse();
      }
    },
    resetData() {
      this.searchName = '';
      this.searchCode = '';
      this.fetchData();
    },
    showAllCollapse() {
      this.show = true;
      // show collapse lv 1
      for (const item of this.listItem) {
        this.$refs[`collapse-${item.id}`].$data.show = true;
      }
      for (const item of this.$refs.collapseAll) {
        // show collapse lv 2
        if (item.$refs[`collapseAllLv2-${item.item.id}`]) {
          item.$refs[`collapseAllLv2-${item.item.id}`].show = true;
        }
        // show collapse lv 3
        if (
          item.$refs[`collapseAllLv3-${item.item.id}`] &&
          item.$refs[`collapseAllLv3-${item.item.id}`].length
        ) {
          for (const itemlv3 of item.$refs[`collapseAllLv3-${item.item.id}`]) {
            itemlv3.show = true;
          }
        }
        // show collapse lv 4
        if (
          item.$refs[`collapseAllLv4-${item.item.id}`] &&
          item.$refs[`collapseAllLv4-${item.item.id}`].length
        ) {
          for (const itemlv4 of item.$refs[`collapseAllLv4-${item.item.id}`]) {
            itemlv4.show = true;
          }
        }
        // show collapse lv 5
        if (
          item.$refs[`collapseAllLv5-${item.item.id}`] &&
          item.$refs[`collapseAllLv5-${item.item.id}`].length
        ) {
          for (const itemlv5 of item.$refs[`collapseAllLv5-${item.item.id}`]) {
            itemlv5.show = true;
          }
        }
      }
    },
    hideAllCollapse() {
      this.show = false;
      for (const item of this.listItem) {
        this.$refs[`collapse-${item.id}`].$data.show = false;
      }
      for (const item of this.$refs.collapseAll) {
        if (item.$refs[`collapseAllLv2-${item.item.id}`]) {
          item.$refs[`collapseAllLv2-${item.item.id}`].show = false;
        }
        if (
          item.$refs[`collapseAllLv3-${item.item.id}`] &&
          item.$refs[`collapseAllLv3-${item.item.id}`].length
        ) {
          for (const itemlv3 of item.$refs[`collapseAllLv3-${item.item.id}`]) {
            itemlv3.show = false;
          }
        }
        // hide collapse lv 4
        if (
          item.$refs[`collapseAllLv4-${item.item.id}`] &&
          item.$refs[`collapseAllLv4-${item.item.id}`].length
        ) {
          for (const itemlv4 of item.$refs[`collapseAllLv4-${item.item.id}`]) {
            itemlv4.show = false;
          }
        }
        // hide collapse lv 5
        if (
          item.$refs[`collapseAllLv5-${item.item.id}`] &&
          item.$refs[`collapseAllLv5-${item.item.id}`].length
        ) {
          for (const itemlv5 of item.$refs[`collapseAllLv5-${item.item.id}`]) {
            itemlv5.show = false;
          }
        }
      }
    },
    highlightMatchesName(text = '') {
      const searchTerm = this.searchName ? this.searchName.trim() : '';

      const matchExists = removeAccents(text)
        .toLowerCase()
        .includes(removeAccents(searchTerm).toLowerCase());

      if (!matchExists) return text;

      const regex = new RegExp(searchTerm, 'ig');
      return text.replace(
        regex,
        (matchedText) =>
          `<strong style="color: #FF2400">${matchedText}</strong>`,
      );
    },
    highlightMatchesCode(text = '') {
      const searchTerm = this.searchCode ? this.searchCode.trim() : '';

      const matchExists = removeAccents(text)
        .toLowerCase()
        .includes(removeAccents(searchTerm).toLowerCase());

      if (!matchExists) return text;

      const regex = new RegExp(searchTerm, 'ig');
      return text.replace(
        regex,
        (matchedText) =>
          `<strong style="color: #FF2400">${matchedText}</strong>`,
      );
    },
    onScrollCategory() {
      if (this.isLoadMore || !this.chunkData.length) return;

      const usersHeading = this.$refs['loadMoreCategory'];
      if (usersHeading) {
        const marginTopUsers = usersHeading.getBoundingClientRect().top;
        const innerHeight = window.innerHeight;
        if (marginTopUsers - innerHeight < -500) {
          this.getDataLoadMore();
        }
      }
    },
    getDataLoadMore() {
      this.isLoadMore = true;
      const nextChunk = this.chunkData.splice(0, 1);
      nextChunk[0].forEach((element) => {
        let item = {
          id: element.id,
          stt: this.count,
          name: element.name,
          code: element.code,
          level: element.level,
          parentId: element.parentId,
        };
        this.listItem.push(item);
        this.count++;
        this.isLoadMore = false;
      });
    },
    validateState(name) {
      if (!this.isNew) {
        const { $dirty, $error } = this.$v[name];
        return $dirty ? !$error : null;
      }
    },
    isValidData(data) {
      var format = /[`!@#$%^&*()+\-={};':"|,.<>?~]/;
      return !format.test(data);
    },
    formatCellByLevel(category, field) {
      let tagHtml = '';
      switch (category.level) {
        case 0:
          tagHtml = `<p >${category[field]}</p>`;
          break;
        case 1:
          tagHtml = `<p class="ml-10">${category[field]}</p>`;
          break;
        case 2:
          tagHtml = `<p class="ml-20">${category[field]}</p>`;
          break;
        case 3:
          tagHtml = `<p class="ml-30">${category[field]}</p>`;
          break;
        case 4:
          tagHtml = `<p class="ml-40">${category[field]}</p>`;
          break;
        case 5:
          tagHtml = `<p class="ml-50">${category[field]}</p>`;
          break;
        default:
          break;
      }
      return tagHtml;
    },
    getListCate: function () {
      this.listCate = [];
      const param = {
        name: '',
        code: '',
      };
      const paramQuery = {
        params: param,
      };
      ApiService.query('categories', paramQuery).then(({ data }) => {
        this.totalRow = data.data.total_row;
        data.data.list_caterogy.forEach((element) => {
          let name = '';
          if (element.level === 1) {
            name = '-' + element.name;
          } else if (element.level === 2) {
            name = '--' + element.name;
          } else if (element.level === 3) {
            name = '---' + element.name;
          } else if (element.level === 4) {
            name = '----' + element.name;
          } else if (element.level === 5) {
            name = '-----' + element.name;
          } else if (element.level === 6) {
            name = '------' + element.name;
          } else {
            name = element.name;
          }
          let item = {
            id: element.id,
            name: name,
            level: element.level,
            parentId: element.parentId,
          };
          this.listCate.push(item);
        });
        this.$nprogress.done();
        this.$nprogress.remove();
      });
    },
    getListCateParent(parentId = null) {
      if (this.isLoadingParentCategories) {
        return Promise.resolve(this.listCateParent);
      }

      this.isLoadingParentCategories = true;
      this.listCateParent = [];
      const param = {
        parentId: parentId,
      };
      const paramQuery = {
        params: param,
      };
      return ApiService.query('category/get-list-parent', paramQuery)
        .then(({ data }) => {
          if (data.status === 1) {
            this.listCateParent = data.data.list_cate_parent || [];
          }
          return this.listCateParent;
        })
        .catch((error) => {
          console.error('Error fetching parent categories:', error);
          return [];
        })
        .finally(() => {
          this.isLoadingParentCategories = false;
        });
    },
    onFilter() {
      this.fetchData();
    },
    fetchData: async function () {
      this.$nprogress.remove();
      if (!this.searchCode || !this.searchName) {
        this.show = false;
      }
      const param = {
        name: this.searchName,
        code: this.searchCode,
      };
      const paramQuery = {
        params: param,
      };
      this.onLoading = true;
      ApiService.query('categories', paramQuery)
        .then(async ({ data }) => {
          this.count = 1;
          this.totalRow = data.data.total_row;
          this.listItem = [];
          const categories = data.data.list_caterogy;
          this.categoryMerges = [...categories];
          // const firstChunk = categories.splice(0, 50);
          categories.forEach((element) => {
            const item = {
              id: element.id,
              stt: this.count,
              name: element.name,
              label: element.name,
              code: element.code,
              level: element.level,
              parentId: element.parentId,
              children: element.children,
            };
            this.listItem.push(item);
            this.count++;
          });
          if (this.searchName || this.searchCode) {
            this.show = false;
          }

          this.chunkData = categories.length ? chunk(categories, 100) : [];

          this.onLoading = false;
        })
        .catch((err) => {
          this.onLoading = false;
          throw new Error(err);
        });
    },
    checkViewOnly: function () {
      let count = 0;
      if (this.checkPermission('CATE_VIEW')) {
        count++;
      }
      if (this.checkPermission('CATE_UPDATE')) {
        count++;
      }
      if (count === 1) {
        return true;
      } else {
        return false;
      }
    },
    makeToastSuccess(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'success',
        solid: true,
      });
    },
    makeToastFaile(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'danger',
        solid: true,
      });
    },
    deleteItem: async function (item) {
      let id = item.id;
      ApiService.delete(`categories/${id}`).then(({ data }) => {
        if (data.status === 1) {
          this.makeToastSuccess(data.message);
          this.fetchData();
          this.show = false;
        }
      });
    },
    showDeleteAlert: function (item) {
      Swal.fire({
        title: 'Xóa danh mục!',
        text: 'Bạn có chắc muốn xóa danh mục này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.deleteItem(item);
        }
      });
    },
    editItem: function (item) {
      this.cateId = item.id;
      this.getCategoryById();
      this.showModalUpdateCate();
    },
    getCategoryById: function () {
      ApiService.get(`categories/${this.cateId}`)
        .then(({ data }) => {
          if (data.status === 1) {
            this.name = data.data.name;
            this.code = data.data.code;
            this.selectedParent = data.data.parentId;
            this.purchasingDepartmentId = data.data.purchasingDepartmentId;
            this.searchPurchasingDepartment =
              data.data.purchasingDepartmentName;
          } else {
            this.makeToastFaile('Tải dữ liệu thất bại!');
          }
        })
        .catch(({ response }) => {
          this.makeToastFaile(response.$error);
        });
    },
    addChildCate: function (item) {
      if (!this.ensureCanCreateCategory()) {
        return;
      }
      this.showModalAddCate();
      this.selectedParent = item.id;
      this.parentCateId = item.id;
      this.parentCateName = item.name;
      this.parentCateCode = item.code;
    },
    showModalAddCate() {
      if (!this.ensureCanCreateCategory()) {
        return;
      }
      this.isNew = true;
      this.selectedParent = null;
      this.name = '';
      this.code = '';
      this.$refs['add-cate-modal'].show();
    },
    hideModalAddCate() {
      this.$refs['add-cate-modal'].hide();
      this.parentCateId = null;
      this.parentCatename = '';
      this.parentCateCode = '';
    },
    showModalUpdateCate() {
      this.isNew = true;
      this.$refs['update-cate-modal'].show();
    },
    hideModalUpdateCate() {
      this.$refs['update-cate-modal'].hide();
    },
    createCategory: function () {
      if (!this.ensureCanCreateCategory()) {
        return;
      }
      this.isNew = false;
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      if (!this.isValidData(this.name)) {
        alert('Tên danh mục không được chứa ký tự đặc biệt!');
        return;
      }
      if (!this.isValidData(this.code)) {
        alert('Mã danh mục không được chứa ký tự đặc biệt!');
        return;
      }
      const name = this.name;
      const code = this.code;
      const parentId = this.parentCateId
        ? this.parentCateId
        : this.selectedParent;
      const data = {
        code: code,
        name: name,
        parentId: parentId,
      };
      ApiService.post('categories', data)
        .then(({ data }) => {
          if (data.status === 1) {
            this.makeToastSuccess(data.message);
            this.fetchData();
            this.getListCate();
            this.hideModalAddCate();
            this.show = false;
          } else {
            this.makeToastFaile(data.message);
          }
        })
        .catch(({ response }) => {
          this.makeToastFaile(response.data.message);
        });
    },
    updateCategory: async function () {
      this.isNew = false;
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      if (!this.isValidData(this.name)) {
        alert('Tên danh mục không được chứa ký tự đặc biệt!');
        return;
      }
      if (!this.isValidData(this.code)) {
        alert('Mã danh mục không được chứa ký tự đặc biệt!');
        return;
      }
      const name = this.name ? this.name.trim() : '';
      const code = this.code ? this.code.trim() : '';
      let data = {
        id: this.cateId,
        name: name,
        code: code,
        parentId: this.selectedParent,
        purchasingDepartmentId: this.purchasingDepartmentId,
      };
      ApiService.put(`categories/${this.cateId}`, data).then(({ data }) => {
        if (data.status === 1) {
          this.makeToastSuccess(data.message);
          this.fetchData();
          this.getListCate();
          this.hideModalUpdateCate();
          this.show = false;
        } else {
          this.makeToastFaile(data.message);
        }
      });
    },
    showMergeTreeModal(item) {
      this.listMergeTreeCate = [];
      const descendants = getDescendantCategories(item, this.listCate);
      const descendantIds = descendants.map((item) => item.id);
      const deep = getDeepByDescendant(item, descendants);

      this.listCate.forEach((cate) => {
        if (
          cate.id !== item.id &&
          item.parentId !== cate.id &&
          !descendantIds.includes(cate.id) &&
          deep + cate.level < 4
        ) {
          this.listMergeTreeCate.push(cate);
        }
      });

      this.cateToBeMerged = item;
      this.targetCateToBeMerged = null;
      this.$refs['merge-tree-cate-modal'].show();
    },
    hideMergeTreeModal() {
      this.$refs['merge-tree-cate-modal'].hide();
    },
    mergeTreeCategory() {
      ApiService.post('/category/move', {
        sourceCateId: this.cateToBeMerged.id,
        destCateId: this.targetCateToBeMerged,
      })
        .then((response) => {
          const { data } = response;
          const { status, message } = data;

          if (status === 1) {
            this.makeToastSuccess(message);
            this.fetchData();
            this.getListCate();
            this.hideMergeTreeModal();
          } else {
            this.makeToastFaile(message);
            this.hideMergeTreeModal();
          }
        })
        .catch(({ response }) => {
          this.makeToastFaile(response.$error);
        });
    },
    getListCateFiltered() {
      return this.listCate.slice(10);
    },
    async popupMergeCate(category) {
      try {
        await this.getListCateParent(category.parentId);

        const parentCategory = this.listCateParent.find(
          (cate) => cate.id === category.parentId,
        );

        if (!parentCategory) {
          this.makeToastFaile('Danh mục cha không tồn tại');
          return;
        }

        this.categoryMerge = {
          picked: category,
          merged: null,
          mergedId: null,
        };

        this.listMergeTreeCate = [];

        this.listCateParent.forEach((cate) => {
          if (cate.parentId === parentCategory.id && cate.id !== category.id) {
            this.listMergeTreeCate.push(cate);
          }
        });
        this.listMergeTreeCate.unshift(parentCategory);
        this.$refs['merge-cate-modal'].show();
      } catch (error) {
        console.error('Error in popupMergeCate:', error);
      }
    },
    onChangeMergeCate(value) {
      const merged = this.listCateParent.find((cate) => cate.id === value);
      if (!merged) {
        throw new Error('Danh mục không tồn tại');
      }
      this.categoryMerge.merged = merged;
    },
    onMergeCate() {
      if (!this.categoryMerge.merged) {
        this.makeToastFaile('Chưa chọn danh mục để gộp');
        return;
      }
      const data = {
        ...this.categoryMerge,
      };
      ApiService.put('category/merge', data).then((response) => {
        if (response.data.status === 1) {
          this.makeToastSuccess(response.data.message);
          this.fetchData();
          this.getListCate();
          this.$refs['merge-cate-modal'].hide();
        } else {
          this.makeToastFaile(response.data.message);
        }
      });
    },
    async getPuchasingDepartment() {
      try {
        const params = {
          page: 1,
          limit: 100,
        };
        const {
          data: { data },
        } = await ApiService.query('purchasing-department', { params });
        this.optionsPurchasingDepartment = data.result;
        this.listPurchasingDepartment = [...this.optionsPurchasingDepartment];
      } catch (err) {
        const message = err.response.data.message || 'Network error';
        this.makeToastFaile(message);
      }
    },
    onSelectedPurchasingDepartment({ item }) {
      this.purchasingDepartmentId = item.id;
      this.searchPurchasingDepartment = item.name;
    },
    onInputChangePurchasingDepartment(searchText) {
      if (!searchText) {
        searchText = '';
        this.purchasingDepartmentId = null;
      }
      this.searchPurchasingDepartment = searchText;
      const filteredData = this.optionsPurchasingDepartment
        .filter((item) => {
          return (
            item.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1 ||
            removeAccents(item.name.toLowerCase()).indexOf(
              removeAccents(searchText.toLowerCase()),
            ) > -1
          );
        })
        .slice(0, this.limit);

      this.listPurchasingDepartment = [...filteredData];
    },
  },
};
</script>
